import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'w-4 h-4 border',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-2',
};

// The hub's own spinner. It mirrors the shared `components/common/Loader` on purpose: this
// module is kept self-contained so it can be lifted into another project without dragging the
// app's component library along.
//
// Hairline weights rather than the old 8px ring, and the two ground rule tokens rather than a
// brand colour: a loading state is structure, and structure in this world is a hairline. The
// leading edge is full-strength ink so the rotation is legible without the ring shouting.
const Spinner: React.FC<SpinnerProps> = ({ size = 'md' }) => (
  <div className="flex justify-center">
    <div
      className={`inline-block animate-spin rounded-full border-rule border-t-ink ${sizeClasses[size]}`}
      role="status"
      aria-label="Loading"
    />
  </div>
);

export default Spinner;
